// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Board from "../../../../../bindings/Board.bs.js";
import * as SeoMeta from "../../../../library/SeoMeta.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as MemberDetail from "../MemberDetail.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PageContentResolver from "../../../../../utils/PageContentResolver.bs.js";

function EdwardPiazza(props) {
  var f_seo_meta = function (v) {
    return JsxRuntime.jsx(SeoMeta.make, {
                meta: v.VAL
              });
  };
  var c = PageContentResolver.parse(props.content);
  var seo_meta = c !== undefined ? Belt_Option.mapWithDefault(c.seo_meta, null, f_seo_meta) : null;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                seo_meta,
                JsxRuntime.jsx(MemberDetail.make, {
                      member: Board.edward
                    })
              ]
            });
}

var make = EdwardPiazza;

var getServerSideProps = PageContentResolver.resolver;

export {
  make ,
  getServerSideProps ,
}
/* Board Not a pure module */
